import React from "react";

// Operators live on Devdesk Pool. Displayed as a brand wall for recognition
// only (no outbound links, no counts); the network keeps growing, so add a
// line here when a new operator goes live and the wall adjusts itself.
export const clients = [
  { name: "D.Buxton United Pools", logo: "/img/clients/debuxton.png" },
  { name: "De-Minister Pools", logo: "/img/clients/deminister.png" },
  { name: "Lawray Pools Fixed Odds", logo: "/img/clients/lawray.png" },
  { name: "Eagle United Pools", logo: "/img/clients/eagle.png" },
  { name: "Praise Pools", logo: "/img/clients/praise.png" },
  { name: "De-Best Global Fixed Odds", logo: "/img/clients/debest.png" },
  { name: "ZionStar Fixed Odds", logo: "/img/clients/zionstar.png" },
];

// Logo wall in the Logifuture style: a seamless, slowly scrolling marquee of
// operator brands, faded at the edges. The track renders the list twice and
// translates by exactly one copy (50% + half the 4rem gap) per loop.
const TrustedBy = ({ heading = "Trusted by leading operators nationwide" }) => {
  return (
    <div className="mt-16 pt-10 border-t border-gray-100">
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider text-center mb-8">
        {heading}
      </p>
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,#000_12%,#000_88%,transparent)]">
        <div className="flex items-center gap-16 w-max animate-logo-marquee motion-reduce:animate-none">
          {[...clients, ...clients].map((client, i) => (
            <div key={i} className="flex items-center justify-center h-16 flex-shrink-0" title={client.name}>
              <img
                src={client.logo}
                alt={client.name}
                className="max-h-14 w-auto object-contain grayscale opacity-60"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedBy;
